import React, { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { GlobalContext } from '@src/context/GlobalContext';
import Header from '@src/components/Header';
import Footer from '@src/components/Footer';
import LayoutContent from '@src/components/LayoutContent';
import './baseLayout.scss';

const BaseLayout = () => {
  const { state: { theme } } = useContext(GlobalContext);
  return (
    <div className="layout-wrapper">
      <Header></Header>
      <LayoutContent>
        <Outlet />
      </LayoutContent>
      <Footer></Footer>
    </div>
  )
}

export default BaseLayout;